<template>
	<div>


		<v-stepper v-model="getAuthStep" class="elevation-0">
			<v-stepper-items>
				<v-stepper-content step="1" >
					<div class="text-center">
						<p class="page-title">LET’S START TOGETHER</p>
						<p class="head--text">Enter your details below</p>
					</div>
					<div class="h-100">
						<v-row justify="center">
							<v-col cols="12" md="4" class="text-center">
								<v-form ref="wholesaler_signup_form"  lazy-validation @submit.prevent="signup()">
									<v-row justify="center">
										<v-col cols="10" md="12" class="py-0 px-2">
											<v-text-field
											:label="$lang.FIRM_NAME"
											v-model="form.firm_name"
											single-line
											outlined
											dense
											:rules="rules.firmNameRule"
											></v-text-field>
										</v-col>

										<v-col cols="10" md="6" class="py-0 px-2">
											<v-text-field
											:label="$lang.MOBILE_NO"
											v-model="form.mobile"
											single-line
											outlined
											dense
											maxlength="10"
											:rules="rules.mobileRule"
											></v-text-field>
										</v-col>
										<v-col cols="10" md="6" class="py-0 px-2">
											<v-text-field
											:label="$lang.LANDLINE_NO"
											v-model="form.landline_number"
											single-line
											outlined
											dense
											maxlength="11"
											:error-messages="(form.landline_number)&&(form.mobile==form.landline_number)?$messages.MATCHING_PHONE_NUMBER_ERROR:''"
											:rules="rules.landlineNumberRule"
											></v-text-field>
										</v-col>

										<v-col cols="10" md="12" class="py-0 px-2">
											<v-text-field
											:label="$lang.EMAIL_ID"
											v-model="form.email"
											single-line
											outlined
											dense
											:rules="rules.emailRule"
											></v-text-field>
										</v-col>

										<v-col cols="10" md="6" class="py-0 px-2">
											<v-text-field
											:label="$lang.PASSWORD"
											v-model="form.password"
											single-line
											outlined
											dense
											type="password"
											:rules="rules.passwordRule"
											></v-text-field>
										</v-col>
										<v-col cols="10" md="6" class="py-0 px-2">
											<v-text-field
											:label="$lang.CONFIRM_PASSWORD"
											v-model="form.confirm_password"
											single-line
											outlined
											dense
											type="password"
											:rules="rules.confirmPasswordRule"
											:error="password_error"
											:error-messages="(form.password!=form.confirm_password)?'Password not match':''"
											></v-text-field>
										</v-col>

										<v-col cols="10" md="6" class="py-0 px-2">
											<v-text-field
											:label="$lang.SHOP_NO"
											v-model="form.shop_number"
											single-line
											outlined
											dense
											></v-text-field>
										</v-col>
										<v-col cols="10" md="6" class="py-0 px-2">

											<v-text-field
											:label="$lang.PIN_CODE"
											v-model="form.pincode"
											single-line
											outlined
											dense
											maxlength="6"
											:rules="rules.pinCodeRule"
											></v-text-field>
										</v-col>

										<v-col cols="10" md="12" class="py-0 px-2">
											<v-textarea
											clearable
											:label="$lang.FULL_ADDRESS"
											v-model="form.full_address"
											single-line
											outlined
											dense
											auto-grow
											rows="2"
											:rules="rules.fullAddressRule"
											></v-textarea>
										</v-col>

										<v-col cols="10" md="12" class="py-0 px-2">
											<v-select
											v-model="form.city"
											:items="city_list"
											item-text="city_name"
											item-value="city_name"
											:label="$lang.CITY"
											@focus="cityAutoComplete"
											@change="setState"
											append-icon="mdi-menu-down"
											single-line
											outlined
											dense
											return-object
											:rules="$rules.cityRule"
											:loading="city_loading"
											>
											<template v-slot:selection="{ item}">
												{{ item.city_name }}, {{ item.state_name }}								
											</template>

											<template v-slot:item="data">
												<v-list-item-content>
													<v-list-item-title v-html="data.item.city_name"></v-list-item-title>
													<v-list-item-subtitle >{{data.item.state_name}}</v-list-item-subtitle>
												</v-list-item-content>
											</template>
										</v-select>
									</v-col>
									<!-- gstin  -->
									<v-col cols="10" md="12" class="py-0 px-2">
										<v-text-field
										:label="$lang.GST_NUMBER"
										v-model="form.gst_number"
										single-line
										outlined
										dense
										maxlength="15"
										:rules="rules.gstNumberRule"
										></v-text-field>
									</v-col>
									<v-col cols="10" md="12" class="py-0 px-2">
										<warehouse-select-box  @get-warehouse="getWarehouse"/>
									</v-col>
									<v-col cols="10" md="12" class="py-0 px-2">
										<v-btn color="primary" class="signup-btn-style" type="submit">
											Sign Up
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</v-col>
					</v-row>



				</div>
			</v-stepper-content>

			<!--  VERIFY OTP -->
			<v-stepper-content step="2">
				<verify-otp />
			</v-stepper-content>
		</v-stepper-items>
	</v-stepper>
</div>
</template>
<script >

import messages  from '../../../app-js/messages.js'
import { mapGetters } from 'vuex'
export default {
	components: {
		VerifyOtp: () => import('../verify-otp/VerifyOtp.vue'),
		WarehouseSelectBox: () => import('@/components/common-components/WarehouseSelectBox.vue'),


	},
	data () {
		return {
			password_error:false,
			city_loading:false,
			city_list:[],
			form:{
				firm_name:"",
				mobile:"",
				landline_number:"",
				email:"",
				password:"",
				confirm_password:"",
				shop_number:"",
				pincode:"",
				full_address:"",
				city:"",
				state:"",
				gst_number:"",
				warehouse:"",

			},
			rules:{
				firmNameRule: [v => !!v || messages.FIRM_NAME_ERROR],
				mobileRule: [
				v=>!!v || messages.MOBILE_NUMBER_ERROR,
				v  => {
					if (!v.trim()) return true;
					if (!isNaN(parseFloat(v)) && v >= 5000000000 && v <= 9999999999) return true;
					return messages.INVALID_MOBILE_NUMBER_ERROR;
				}
				],
				emailRule: [
				v => !!v || messages.EMAIL_ERROR,
				v => /.+@.+\..+/.test(v) || messages.EMAIL_MUST_BE_VALID,
				],
				passwordRule: [v => !!v || messages.PASSWORD_ERROR],
				confirmPasswordRule: [v => !!v || messages.CONFIRM_PASSWORD_ERROR],
				shopNumberRule: [v => !!v || messages.CONFIRM_PASSWORD_ERROR],
				pinCodeRule: [v => !!v || messages.PIN_CODE_ERROR],
				fullAddressRule: [v => !!v || messages.FULL_ADDRESS_ERROR],
				cityRule: [v => !!v || messages.CITY_ERROR],
				stateRule: [v => !!v || messages.STATE_ERROR],
				landlineNumberRule: [
				v=>!!v || messages.LANDLINE_NUMBER_ERROR,
				// v  => {
				// 	if (!v.trim()) return true;
				// 	if (!isNaN(parseFloat(v)) && v >= 500000000 && v <= 99999999999) return true;
				// 	return messages.INVALID_LANDLINE_NUMBER_ERROR;
				// }
				],
				gstNumberRule: [
				v=>!!v || messages.GST_NUMBER_ERROR,
				v  => {
					var regex = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;    
					if(!regex.test(v)){    
						return messages.INVALID_GST_NUMBER_ERROR
					}  
					return true
				} 
				],

			},
		}
	},
	computed: mapGetters({
		getAuthStep: 'auth/getAuthStep'
	}),
	created(){
		console.log(sessionStorage.getItem("token"))
		this.$store.dispatch('auth/setAuthStep', 1)
		// this.initAutocomplete()
	},
	methods:{
		/* set the  selected city and state */ 
		setState(item){
			console.log(item)
			if(item){
				console.log(item.state_name)
				this.form.state=item.state_name
				this.$emit('get-state',item.state_name)
			}		
			else
				this.form.state=""
		},

		getWarehouse(warehouse){
			console.log(warehouse)
			this.form.warehouse=warehouse
		},
		/* sign up form submit */ 
		signup(){
			const self=this;
			if (this.$refs.wholesaler_signup_form.validate()==false)
				return false

			var	 form = new URLSearchParams();
			form.append("firm_name",self.form.firm_name);
			form.append("mobile",self.form.mobile);
			form.append("landline_number",self.form.landline_number);
			form.append("email",self.form.email);
			form.append("password",self.form.password);
			// form.append("confirm_password",self.form.confirm_password);
			form.append("shop_number",self.form.shop_number);
			form.append("pincode",self.form.pincode);
			form.append("full_address",self.form.full_address);
			form.append("city",self.form.city);
			form.append("state",self.form.state);
			form.append("gst_number",self.form.gst_number);
			form.append("warehouse_id",self.form.warehouse.id);

			const successHandler = (response) => {
				console.log(response)
				if(response.data.success){
					if(response.data.flag_user_exists){
						this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:response.data.message, color:'error' })
					}
					else{
						this.$store.dispatch('auth/setOtpToken', {otp_token:response.headers["otp-token"], mobile:self.form.mobile, email:self.form.email,action:"" })
						this.$store.dispatch('auth/setAuthStep', 2)
					}
				}
			};
			this.request_POST(self,this.$urls.REGISTER_WHOLESALER,form,successHandler)

		},

	}

}
</script>